import TrackingLink from '../link/tracking-link'
import ComponentWithSearchClient from '../search/searchClientProvider'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'
import BoxWidget from '../../components/box-widget'

interface TitleOnlyProps {
  title: string
}

interface TagsOnlyProps {
  tags: string[]
}

interface TagsProps extends TitleOnlyProps, TagsOnlyProps {}

export const widgetName = 'tag_cloud'

export class Tags extends ComponentWithSearchClient<TagsProps> {
  render ({ title, tags }: TagsProps) {
    if (!tags.length) return null
    return (
      <BoxWidget className='widget--tags qa-widget-popular-subjects'>
        {title ? <h3 class='widget-title'>{title}</h3> : null}
        <TrackingLink
          tag='ul'
          track={{ type: 'Sidebar Widget Clicked', widget: 'tag cloud' }}
          gaEvents={{ eventCategory: 'Homepage', eventAction: 'Widget Clicked', eventLabel: { Type: 'tagcloud' } }}
          class='public-tags list list--float js-collapsable--content qa-tags-list'
        >
          {
            tags.map(tag => {
              return (
                <li key={tag}>
                  <a class='tag--pill qa-tag-pill' href={`/search/index?q=${encodeURIComponent(tag)}&search_type=tag`}>{tag}</a>
                </li>
              )
            })
          }
        </TrackingLink>
      </BoxWidget>
    )
  }
}

interface TagHit {
  value: string
  highlighted: string
  count: number
}

interface Props extends TitleOnlyProps {
  count: number
}

export const config = z.object({
  title: z.string(),
  count: z.number()
})

type Config = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<Config, Props> = async (_, config) => {
  return {
    title: config.title,
    count: config.count
  }
}

export default class extends ComponentWithSearchClient<Props, TagsOnlyProps> {
  constructor () {
    super()
    this.state = {
      tags: []
    }
  }

  async componentDidMount () {
    await super.componentDidMount()
    const result = await this.algoliaIndex.searchForFacetValues({
      maxFacetHits: this.props.count,
      facetName: 'tags',
      facetingAfterDistinct: true,
      facetQuery: ''
    })
    this.setState({
      tags: result.facetHits.map(({ value }: TagHit) => value)
    })
  }

  render (props: Props) {
    return <Tags tags={this.state.tags} title={props.title} />
  }
}
